import * as React from "react";
import { Link } from "react-router-dom";
import CredentialStore from "../../../../stores/CredentialStore";
import { GetCredentialList } from "../../../../actions/CredentialActions";
import actionTypes from "../../../../actions/ActionTypes";
class CredentialSidebar extends React.Component {
  //isList: Array<BPModel>;
  constructor(props) {
    super(props);
    this.state = {
      credentialList: [],
      secretsLoaded: false
    };
    this.onReceiveSecretChange = this.onReceiveSecretChange.bind(this);
  }
  componentDidMount() {
    CredentialStore.addChangeListener(this.onReceiveSecretChange);
    GetCredentialList();
  }
  componentWillUnmount() {
    CredentialStore.removeChangeListener(this.onReceiveSecretChange);
  }
  onReceiveSecretChange() {
    let lastChange = CredentialStore.lastChange();
    if (lastChange === actionTypes.CredentialList) {
      let credentials = CredentialStore.getCredentials();
      this.setState({
        credentialList: credentials,
        secretsLoaded: true
      });
    }
  }
  render() {
    let listOfCredentials;
    console.log("loc");
    console.log(this.state.credentialList);
    if (this.state.credentialList !== void 0) {
      listOfCredentials = this.state.credentialList.map((credential) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" }, key: credential.id }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/CredentialView/" + credential.id,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        /* @__PURE__ */ React.createElement("i", { title: "UnEncrypted", style: { color: "#86AFC0" }, className: "fa-solid fa-user-lock" }),
        " ",
        credential.name
      )));
    } else {
      listOfCredentials = /* @__PURE__ */ React.createElement("div", null, "No credentials defined");
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "245px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/Secret",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("i", { style: { color: "#FFCA48" }, className: "fa-solid fa-user-lock" }), "   ", "Credentials")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "50%", overflow: "auto" } }, listOfCredentials),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/CredentialView/0" }, "New Credential")
    );
  }
}
export default CredentialSidebar;
